import { unwrap } from '@/lib/apiEnvelope'
import { httpClient } from '@/lib/httpClient'
import type { ApiResponse, Paginated } from '@/types/api'

import type { Notificacao, NotificacaoListFilters } from '../types/notificacao'

export const notificacoesApi = {
  list: async (filters: NotificacaoListFilters): Promise<Paginated<Notificacao>> => {
    const params: Record<string, string | number | boolean> = {
      page: filters.page,
      pageSize: filters.pageSize,
    }
    if (filters.apenasNaoLidas) params.apenasNaoLidas = true
    const response = await httpClient.get<ApiResponse<Paginated<Notificacao>>>('/notificacoes', {
      params,
    })
    return unwrap(response)
  },

  contador: async (): Promise<number> => {
    const response = await httpClient.get<ApiResponse<number>>('/notificacoes/nao-lidas/contador')
    return unwrap(response)
  },

  marcarLida: async (id: string): Promise<void> => {
    await httpClient.patch(`/notificacoes/${id}/lida`)
  },

  marcarTodasLidas: async (): Promise<number> => {
    const response = await httpClient.patch<ApiResponse<number>>('/notificacoes/lidas')
    return unwrap(response)
  },
}
